import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as MuiCore from '@material-ui/core';
import PhoneIcon from '@material-ui/icons/Phone';
import PurchaseNumberDialog from '../account/PurchaseNumberDialog';

import { FormattedNumber } from './BlockNumbers/blockNumbers.columns';

class PhoneNumbersCard extends Component {
    state = {
        purchaseDialogOpen: false
    };

    render() {
        const { phoneNumbers, classes, accountId } = this.props;
        const hasPhoneNumbers = phoneNumbers && phoneNumbers.length > 0;

        return (
            <MuiCore.Box className={classes.section}>
                <MuiCore.Box className={classes.sectionHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <MuiCore.Box className={classes.sectionTitle}>
                        <PhoneIcon />
                        <MuiCore.Typography variant="h6" style={{ fontFamily: 'Sofia-bold' }}>Inbound Numbers</MuiCore.Typography>
                    </MuiCore.Box>
                    
                    {!hasPhoneNumbers && (
                        <MuiCore.Button
                            variant="contained"
                            style={{ 
                                backgroundColor: '#7F2062', 
                                color: '#fff', 
                                fontFamily: 'Sofia',
                                fontWeight: 600,
                                textTransform: 'none',
                                borderRadius: 100,
                                paddingLeft: 24,
                                paddingRight: 24
                            }}
                            onClick={() => this.setState({ purchaseDialogOpen: true })}
                        >
                            Add Phone Number
                        </MuiCore.Button>
                    )}
                </MuiCore.Box>

                {hasPhoneNumbers ? (
                <>
                    {/* Table Header */}
                    <MuiCore.Box style={{ 
                        display: 'grid', 
                        gridTemplateColumns: '2fr 1fr 1.5fr 1fr',
                        gap: 16,
                        padding: '12px 16px',
                        borderBottom: '2px solid #e0e0e0',
                        fontWeight: 600,
                        color: '#666',
                        marginTop: 16,
                        fontFamily: 'Sofia'
                    }}>
                        <MuiCore.Typography variant="body2" style={{ fontWeight: 600, fontFamily: 'Sofia' }}>
                            Inbound Phone Number
                        </MuiCore.Typography>
                        <MuiCore.Typography variant="body2" style={{ fontWeight: 600, fontFamily: 'Sofia' }}>
                            Account
                        </MuiCore.Typography>
                        <MuiCore.Typography variant="body2" style={{ fontWeight: 600, fontFamily: 'Sofia' }}>
                            Location
                        </MuiCore.Typography>
                        <MuiCore.Typography variant="body2" style={{ fontWeight: 600, fontFamily: 'Sofia' }}>
                            Status
                        </MuiCore.Typography>
                    </MuiCore.Box>

                    {/* Table Rows */}
                    {phoneNumbers.map((phone, index) => (
                        <MuiCore.Box 
                            key={phone.phoneNumberId || index}
                            style={{ 
                                display: 'grid',
                                gridTemplateColumns: '2fr 1fr 1.5fr 1fr',
                                gap: 16,
                                padding: '16px',
                                borderBottom: '1px solid #f0f0f0',
                                alignItems: 'center'
                            }}
                        >
                            <MuiCore.Box style={{ display: 'flex', alignItems: 'center' }}>
                                <FormattedNumber number={phone.phoneNumber} />
                            </MuiCore.Box>
                            <MuiCore.Typography variant="body2" style={{ fontFamily: 'Sofia' }}>{phone.accountNumber || 'N/A'}</MuiCore.Typography>
                            <MuiCore.Typography variant="body2" style={{ fontFamily: 'Sofia' }}>{phone.locationName || 'DEFAULT'}</MuiCore.Typography>
                            <MuiCore.Typography 
                                variant="body2" 
                                style={{ 
                                    color: phone.status === 'ACTIVE' ? '#4caf50' : '#666',
                                    fontWeight: 500,
                                    fontFamily: 'Sofia'
                                }}
                            >
                                {phone.status}
                            </MuiCore.Typography>
                        </MuiCore.Box>
                    ))}
                </>
            ) : (
                <MuiCore.Box style={{ padding: '32px', textAlign: 'center' }}>
                    <MuiCore.Typography variant="body2" color="textSecondary" style={{ fontFamily: 'Sofia' }}>
                        You currently do not have an Inbound Number. Click "Add Phone Number" to get started.
                    </MuiCore.Typography>
                </MuiCore.Box>
            )}
            
            <PurchaseNumberDialog
                open={this.state.purchaseDialogOpen}
                onClose={() => this.setState({ purchaseDialogOpen: false })}
                accountId={accountId}
            />
        </MuiCore.Box>
        );
    }
}

const mapStateToProps = (state) => ({
    accountId: state.account.account?.accountId
});

export default connect(mapStateToProps)(PhoneNumbersCard);
